"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
/** *******************************************************************************************************************
  Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
  
  Licensed under the Apache License, Version 2.0 (the "License").
  You may not use this file except in compliance with the License.
  You may obtain a copy of the License at
  
      http://www.apache.org/licenses/LICENSE-2.0
  
  Unless required by applicable law or agreed to in writing, software
  distributed under the License is distributed on an "AS IS" BASIS,
  WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
  See the License for the specific language governing permissions and
  limitations under the License.                                                                              *
 ******************************************************************************************************************** */
const react_1 = __importStar(require("react"));
const Grid_1 = __importDefault(require("@material-ui/core/Grid"));
const Typography_1 = __importDefault(require("@material-ui/core/Typography"));
const core_1 = require("@material-ui/core");
const Stack_1 = __importDefault(require("../Stack"));
const Text_1 = __importDefault(require("../../components/Text"));
const useStyles = core_1.makeStyles((theme) => ({
    root: {},
    headerRow: {
        backgroundColor: theme.palette.primary.main,
        paddingTop: theme.spacing(4),
    },
    header: {
        padding: theme.spacing(1),
        color: theme.palette.primary.contrastText,
    },
    title: {
        fontSize: '44px',
        lineHeight: '50px',
    },
    subTitle: {
        fontSize: '44px',
        lineHeight: '50px',
        fontWeight: 300,
    },
    action: {
        padding: theme.spacing(1),
    },
    contentArea: {
        padding: theme.spacing(1),
        color: theme.palette.grey[900],
        marginBottom: theme.spacing(1),
    },
    sidebarArea: ({ sidebarMarginTop }) => ({
        padding: theme.spacing(1),
        marginTop: `${sidebarMarginTop}px`,
    }),
}));
/**
 * Basic layout for Get Started page, with place holders for main content, sidebar and action.
 */
const GetStarted = ({ category, title, subTitle, description, action, sidebar, children, }) => {
    var _a, _b, _c, _d;
    const headerRef = react_1.useRef(null);
    const actionRef = react_1.useRef(null);
    const [sidebarMarginTop, setSidebarMarginTop] = react_1.useState(-40);
    react_1.useEffect(() => {
        var _a, _b, _c, _d, _e, _f;
        if (((_a = headerRef.current) === null || _a === void 0 ? void 0 : _a.offsetHeight) && ((_b = actionRef.current) === null || _b === void 0 ? void 0 : _b.offsetHeight)) {
            const calc = (((_c = actionRef.current) === null || _c === void 0 ? void 0 : _c.offsetTop) || 0) +
                (((_d = actionRef.current) === null || _d === void 0 ? void 0 : _d.offsetHeight) || 0) -
                ((((_e = headerRef.current) === null || _e === void 0 ? void 0 : _e.offsetTop) || 0) + (((_f = headerRef.current) === null || _f === void 0 ? void 0 : _f.offsetHeight) || 0)) +
                10;
            setSidebarMarginTop(calc);
        }
    }, [
        setSidebarMarginTop,
        (_a = actionRef.current) === null || _a === void 0 ? void 0 : _a.offsetTop,
        (_b = headerRef.current) === null || _b === void 0 ? void 0 : _b.offsetTop,
        (_c = actionRef.current) === null || _c === void 0 ? void 0 : _c.offsetHeight,
        (_d = headerRef.current) === null || _d === void 0 ? void 0 : _d.offsetHeight,
    ]);
    const styles = useStyles({ sidebarMarginTop });
    return (react_1.default.createElement(Grid_1.default, { container: true, className: styles.root },
        react_1.default.createElement(Grid_1.default, { item: true, xs: 12, className: styles.headerRow },
            react_1.default.createElement(Grid_1.default, { container: true, justify: "center", ref: headerRef },
                react_1.default.createElement(Grid_1.default, { item: true, xs: 10, lg: 8, className: styles.header },
                    react_1.default.createElement(Text_1.default, null, category)),
                react_1.default.createElement(Grid_1.default, { item: true, xs: 10, sm: 6, lg: 5, xl: 6, className: styles.header },
                    react_1.default.createElement(Stack_1.default, null,
                        react_1.default.createElement(Typography_1.default, { variant: "h1", className: styles.title }, title),
                        react_1.default.createElement(Typography_1.default, { className: styles.subTitle }, subTitle),
                        react_1.default.createElement(Text_1.default, null, description))),
                react_1.default.createElement(Grid_1.default, { item: true, xs: 10, sm: 4, lg: 3, xl: 2, className: styles.action },
                    react_1.default.createElement("div", { ref: actionRef }, action)))),
        react_1.default.createElement(Grid_1.default, { item: true },
            react_1.default.createElement(Grid_1.default, { container: true, justify: "center" },
                react_1.default.createElement(Grid_1.default, { item: true, xs: 10, sm: 6, lg: 5, xl: 6, className: styles.contentArea }, children),
                react_1.default.createElement(Grid_1.default, { item: true, xs: 10, sm: 4, lg: 3, xl: 2, className: styles.sidebarArea }, sidebar)))));
};
exports.default = GetStarted;
//# sourceMappingURL=index.js.map